import { getTrackingId } from "./track";
import axiosResiInstance from "../http/axiosResi";

const fetch = (tracking_id) => {
    return axiosResiInstance.get("/favorites", {
        params: {
            tracking_id,
        },
    });
};

const get = (listing) => {
    return axiosResiInstance.get(`/favorites/${listing.id}`);
};

const remove = (listing) => {
    return axiosResiInstance.delete(`/favorites/${listing.id}`);
};

const create = (listing) => {
    return axiosResiInstance.post("/favorites", {
        listing: listing.id,
    });
};

const getFavorites = async () => {
    const trackingId = await getTrackingId();

    if (!trackingId) {
        return [];
    }

    const favorites = await fetch(trackingId);

    return favorites.data.data;
};

export const deleteFavorite = async (listing) => {
    try {
        await remove(listing);
    } catch (e) {}

    await getFavorites();
};

export const saveFavorite = async (listing) => {
    try {
        await create(listing);
    } catch (e) {}

    await getFavorites();
};

export const isFavorite = async (listing) => {
    let isFavorited = true;

    try {
        await get(listing);
    } catch (e) {
        isFavorited = false;
    }

    return isFavorited;
};
